// extracted by mini-css-extract-plugin
export default {"wrapper":"box-status_wrapper__ewAyn"};